import { useQuery } from '@tanstack/react-query';

import { apiCall, apiClient } from 'shared/client/apiClient';

type GetLatestPBLSnapshotIdOptions = {
  pblDraftId: string;
  publishedOnly?: boolean;
};

export const latestPBLSnapshotIdQueryKey = ({
  pblDraftId,
  publishedOnly
}: {
  pblDraftId?: string;
  publishedOnly?: boolean;
}) => ['pbl-snapshot', 'latest-pbl-id', { pblDraftId, ...(publishedOnly && { publishedOnly }) }] as const;

export const getLatestPBLSnapshotId = async ({ pblDraftId, publishedOnly }: GetLatestPBLSnapshotIdOptions) => {
  return apiCall(
    apiClient.GET('/pbl-snapshots/latest-id', {
      params: {
        query: {
          pblDraftId,
          ...(publishedOnly && { publishedOnly: 'true' })
        }
      }
    })
  );
};

type UseGetLatestPBLSnapshotIdQueryOptions = {
  enabled?: boolean;
  pblDraftId?: string;
  publishedOnly?: boolean;
};

export const useGetLatestPBLSnapshotIdQuery = ({
  enabled,
  pblDraftId,
  publishedOnly
}: UseGetLatestPBLSnapshotIdQueryOptions) => {
  return useQuery({
    queryKey: latestPBLSnapshotIdQueryKey({ pblDraftId, publishedOnly }),
    queryFn: () => getLatestPBLSnapshotId({ pblDraftId: pblDraftId as string, publishedOnly }),
    enabled: !!pblDraftId && enabled !== false
  });
};
